import { PickerCallback } from "react-google-drive-picker/dist/typeDefs";
import {
  DASHBOARD_ENTITIES,
  FILE_UPLOAD_ERRORS,
  MimeTypes,
} from "../../common/constants";
import { clauseCheckDocStatus, DASHBOARD_FEATURES } from "./constants";
import { ClauseCheckObjectType } from "./types";

export const getFileNameWithoutExtension = (fileName: string) => {
  const words = fileName?.split(".");
  if (Array.isArray(words) && words.length > 0) {
    words.pop();
    return words.join();
  }
  return fileName;
};

export const addDocExtentionIfMissing = (fileName: string) => {
  const words = fileName?.split(".doc").join().split(".pdf");

  if (words.length === 1) {
    return fileName + ".docx";
  }
  return fileName;
};

export const getUnReviewedDocuments = (docs: ClauseCheckObjectType[]) => {
  const unreviewedFiles = docs?.filter(
    (doc: ClauseCheckObjectType) =>
      doc.status !== clauseCheckDocStatus.CLAUSE_CHECK_READY
  );
  return unreviewedFiles?.length > 0;
};

export const handleValidationForDashboardEntity = (body: {
  entity: string;
  data: PickerCallback;
}) => {
  const { entity, data } = body;
  const docs = data?.docs;
  let errorMessage = "";
  let isSomeNonSupportedFileFormatPresent = [];
  switch (entity) {
    case DASHBOARD_ENTITIES.CLAUSE_CHECK:
      // const moreDocsSelectedThenLimit =
      //   docs?.length > FILES_LIMIT_FROM_DRIVE_UPLOAD;
      // if (moreDocsSelectedThenLimit) {
      //   errorMessage += FILE_UPLOAD_ERRORS.NUMBER_OF_FILES_LIMIT_REACHED;
      // }
      // isSomeNonSupportedFileFormatPresent = docs?.filter((file: any) => {
      //   return file.mimeType !== MimeTypes.pdf;
      // });

      // if (
      //   isSomeNonSupportedFileFormatPresent &&
      //   isSomeNonSupportedFileFormatPresent?.length > 0
      // )
      //   errorMessage += " " + FILE_UPLOAD_ERRORS.ONLY_PDFS_ARE_SUPPORTED;
      break;
    case DASHBOARD_ENTITIES.CONTRACT_REVIEW:
      isSomeNonSupportedFileFormatPresent = docs?.filter((file: any) => {
        return file.mimeType === MimeTypes.pdf;
      });
      if (
        isSomeNonSupportedFileFormatPresent &&
        isSomeNonSupportedFileFormatPresent?.length > 0
      )
        errorMessage += FILE_UPLOAD_ERRORS.PDF_IS_NOT_SUPPORTED;
      break;
    case DASHBOARD_ENTITIES.CONTRACT_DRAFTING:
      break;

    case DASHBOARD_ENTITIES.RFX_EVALUATION:
      break;

    default:
      break;
  }
  return errorMessage;
};

export const getFilteredDashboardFeatures = (
  isClauseCheckAllowed: boolean | undefined,
  isContracRedliningAllowed: boolean | undefined
) => {
  const filteredDashboardFeatures = Object.values(DASHBOARD_FEATURES).filter(
    (featureKey) => {
      // // if only clause check is allowed
      // if (isClauseCheckAllowed && !isContracRedliningAllowed) {
      //   return featureKey !== DASHBOARD_FEATURES.CONTRACT_REDLINING;
      // }
      // // if only redlining is allowed
      // else if (!isClauseCheckAllowed && isContracRedliningAllowed) {
      //   return (
      //     featureKey !== DASHBOARD_FEATURES.CLAUSE_CHECK
      //   );
      // }
      // return true;
      if (isClauseCheckAllowed && !isContracRedliningAllowed) {
        return featureKey !== DASHBOARD_FEATURES.CONTRACT_REDLINING;
      }
      // if only redlining is allowed
      else if (!isClauseCheckAllowed && isContracRedliningAllowed) {
        return (
          featureKey !== DASHBOARD_FEATURES.RFX_EVALUATION &&
          featureKey !== DASHBOARD_FEATURES.RFX_GENERATOR
        );
      } else if (!isClauseCheckAllowed && isContracRedliningAllowed) {
        return (
          featureKey !== DASHBOARD_FEATURES.CLAUSE_CHECK &&
          featureKey !== DASHBOARD_FEATURES.CONTRACT_DRAFTING &&
          featureKey !== DASHBOARD_FEATURES.TALK_TO_CONTRACT &&
          featureKey !== DASHBOARD_FEATURES.CONTRACT_REDLINING
        );
      }
      return true;
      // if (isClauseCheckAllowed && !isContracRedliningAllowed) {
      //   return (
      //     featureKey !== DASHBOARD_FEATURES.RFX_EVALUATION &&
      //     featureKey !== DASHBOARD_FEATURES.RFX_GENERATOR 
      //   );
      // } else if (!isClauseCheckAllowed && isContracRedliningAllowed) {
      //   return (
      //     featureKey !== DASHBOARD_FEATURES.CLAUSE_CHECK &&
      //     featureKey !== DASHBOARD_FEATURES.CONTRACT_DRAFTING &&
      //     featureKey !== DASHBOARD_FEATURES.TALK_TO_CONTRACT&&
      //     featureKey !== DASHBOARD_FEATURES.CONTRACT_REDLINING
      //   );
      // }
      // return true;
    }
  );
  return filteredDashboardFeatures;
};

export function getFileExtension(filename = "") {
  return filename.slice(filename.lastIndexOf(".")).toLowerCase();
}
export function isPDF(filename = "") {
  return getFileExtension(filename) === ".pdf";
}
